module.exports = __webpack_public_path__ + "img/Hotmart-4-pt.33a36dd3.png";